import React, { useMemo } from 'react';

const PRESETS = {
  winter: {
    chars: ['❄', '❅', '❆', '·', '✦'],
    count: 48,
    className: 'season-fx season-fx--winter',
  },
  autumn: {
    chars: ['🍂', '🍁', '🍂', '·'],
    count: 36,
    className: 'season-fx season-fx--autumn',
  },
  spring: {
    chars: ['🌸', '✿', '❀', '·', '✦'],
    count: 40,
    className: 'season-fx season-fx--spring',
  },
  summer: {
    chars: ['✦', '·', '✧', '☀', '✧'],
    count: 32,
    className: 'season-fx season-fx--summer',
  },
};

/** Seasonal particle overlay (snow / leaves / petals / sun sparks). */
const SeasonFx = ({ season, count }) => {
  const preset = PRESETS[season];
  const n = count ?? preset?.count ?? 40;

  const particles = useMemo(() => {
    if (!preset) return [];
    return Array.from({ length: n }, (_, i) => {
      const size = season === 'summer'
        ? 6 + (i % 5) * 1.8
        : 10 + (i % 7) * 2.2;
      const left = ((i * 37) % 100) + (i % 5) * 0.3;
      const duration = (season === 'summer' ? 12 : 9) + (i % 11) * 1.4;
      const delay = -((i * 1.7) % 14);
      const drift = 16 + (i % 9) * 10;
      const opacity = season === 'summer'
        ? 0.25 + (i % 5) * 0.1
        : 0.4 + (i % 5) * 0.12;
      const char = preset.chars[i % preset.chars.length];
      return { id: i, size, left, duration, delay, drift, opacity, char };
    });
  }, [preset, n, season]);

  if (!preset) return null;

  return (
    <div className={preset.className} aria-hidden>
      {particles.map(p => (
        <span
          key={p.id}
          className="season-particle"
          style={{
            left: `${p.left}%`,
            fontSize: p.size,
            opacity: p.opacity,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--drift': `${p.drift}px`,
          }}
        >
          {p.char}
        </span>
      ))}
    </div>
  );
};

export default SeasonFx;
